import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { postDeleteAdditionalWork } from '../services/postDeleteAdditionalWork.service';

export const deleteAdditionalWork = createAsyncThunk(
  'expenseTracking/deleteAdditionalWork',
  async (additionalWorkId, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    if (!selectedProjectId) {
      throw new Error('No project id given');
    }

    if (!additionalWorkId) {
      throw new Error('No additional work id given');
    }

    await postDeleteAdditionalWork(selectedProjectId, additionalWorkId);

    return additionalWorkId;
  }
);
